import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增节假日")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("维护")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加方案")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("减少方案")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs';
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'
import message from '@/store/modules/message';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  // 查询节假日方案
  'POST/checkin_holidays/list': fetchList,
  // 创建节假日方案
  'POST/checkin_holidays': checkin_holidaysApi,
  // 修改节假日
  'PATCH/checkin_holidays': checkin_holidaysEditApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
fetchData()

// 节假日设置
const holidayTit = ref<string>('新增节假日')
const typeFigure = ref<number>(1)
const dateArr = ref<any[]>([])
// 计算日期范围
const dateChnage = (daterange: string[]) => {
  dateArr.value = []
  if(!daterange) return;
  // 获取日期数组
  let startDate = dayjs(daterange[0])
  let endDate = dayjs(daterange[1])
  while (startDate.isBefore(endDate) || startDate.isSame(endDate)) {
    dateArr.value.push({
      date: startDate.format('YYYY-MM-DD'),
      type1: '',
      type2: '',
      type3: '',
    })
    startDate = startDate.add(1, 'day')
  } 
}

const addFigure = () => {
  typeFigure.value ++
  dateArr.value.map(date => {
    date['type' + typeFigure.value ] = ''
  })
}

const isShowGenerate = ref<boolean>(false)
const generateObj: any = reactive({
  id: null,
  date: '',
  description: '',
})

// 创建节假日
const showGenerateHandle = () => {
  dateArr.value = []
  generateObj.date = []
  generateObj.description = ''
  holidayTit.value = '新增节假日'
  isShowEdit.value = false
  isShowGenerate.value = true
}

// 维护节假日
const isShowEdit = ref<boolean>(false)
const showModify = (row: any) => {
  holidayTit.value = '维护节假日'
  generateObj.id = row.id
  generateObj.date = [row.startDate, row.endDate]
  generateObj.description = row.description
  typeFigure.value = row.holidaySchemes.length
  dateArr.value = []
  row.holidaySchemes.map((e: any, priorityInd: number) => {
    e.schemes.map((date: any, index: number) => {
      date['type' + (priorityInd + 1)] = date.type
      dateArr.value[index] = Object.assign(dateArr.value[index] || {}, date)
    })
  })

  isShowEdit.value = true
  isShowGenerate.value = true
}

const generateHandle = () => {
  if(!generateObj.description){
    ElMessage.warning('请备选择或输入备注')
    return
  }
  let holidaySchemes: any = []
  for (let index = 1; index <= typeFigure.value; index++) {
    holidaySchemes[index - 1] = {schemes: []}
    for (let rowInd = 0; rowInd < dateArr.value.length; rowInd++) {
      // 校验方案选择是否有空
      if(!dateArr.value[rowInd]['type' + index]){
        ElMessage.warning(`请选择${dateArr.value[rowInd].date}方案${index}`)
        // 表格内提示
        // dateArr.value[rowInd].isErr = true
        return false
      }
      // 数据处理
      holidaySchemes[index - 1].schemes.push({
        date: dateArr.value[rowInd].date,
        type: dateArr.value[rowInd]['type' + index],
        priority: index
      })
    }
  }
  const param = {
    id: generateObj.id,
    startDate: generateObj.date?.[0],
    endDate: generateObj.date?.[1],
    description: generateObj.description,
    holidaySchemes,
  }
  // 编辑
  if(isShowEdit.value){
    checkin_holidaysEditApi(param).then(() => {
      ElMessage.success('成功')
      isShowGenerate.value = false
      fetchData()
    })
    return
  }
  checkin_holidaysApi(param).then(() => {
    ElMessage.success('成功')
    isShowGenerate.value = false
    fetchData()
  })
}


// ---------
const formatHoliday = (row: any, column: any, cellValue: any, index: any) => {
  switch (cellValue) {
    case 'Festive':
      return '节日'
    case 'Holiday':
      return '假日'
    case 'WorkDay':
      return '工作日'
    default:
      return '-'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      disabled: _unref(MI_identify),
      class: "mb-10 mt-10",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showGenerateHandle())),
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_el_button, {
      disabled: _unref(MI_identify),
      type: "info",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)())),
      icon: "refresh"
    }, null, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      style: {"width":"900px"},
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 40 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "开始时间",
          prop: "startDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "结束时间",
          prop: "endDate"
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "description",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (showModify(row))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mt-10",
      style: {"float":"none"},
      "page-sizes": [30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: holidayTit.value,
      modelValue: isShowGenerate.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isShowGenerate).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (isShowGenerate.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: generateHandle,
          type: "primary",
          disabled: dateArr.value.length === 0
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        (isShowGenerate.value)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              ref: "holidayRef",
              model: _unref(generateObj),
              "label-width": "120px",
              inline: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "日期范围：",
                  prop: "date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(generateObj).date,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(generateObj).date) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "daterange",
                      style: {"width":"350px"},
                      "start-placeholder": "开始日期",
                      "range-separator": "至",
                      "end-placeholder": "结束日期",
                      onChange: dateChnage
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "备注：",
                  prop: "description",
                  rules: [{required: true, message: '请选择或输入备注', trigger: 'change'}]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(generateObj).description,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(generateObj).description) = $event)),
                      placeholder: "请选择备注",
                      "allow-create": true,
                      filterable: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "元旦",
                          value: "元旦"
                        }),
                        _createVNode(_component_el_option, {
                          label: "春节",
                          value: "春节"
                        }),
                        _createVNode(_component_el_option, {
                          label: "清明节",
                          value: "清明节"
                        }),
                        _createVNode(_component_el_option, {
                          label: "劳动节",
                          value: "劳动节"
                        }),
                        _createVNode(_component_el_option, {
                          label: "端午节",
                          value: "端午节"
                        }),
                        _createVNode(_component_el_option, {
                          label: "中秋节",
                          value: "中秋节"
                        }),
                        _createVNode(_component_el_option, {
                          label: "国庆节",
                          value: "国庆节"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider),
                _createVNode(_component_el_button, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (addFigure())),
                  disabled: typeFigure.value >= 3,
                  class: "mb-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (typeFigure.value--)),
                  disabled: typeFigure.value <= 1,
                  class: "mb-10",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_table, {
                  data: dateArr.value,
                  border: "",
                  "max-height": "500px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "日期",
                      prop: "date",
                      width: "120"
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeFigure.value, (typeIndex) => {
                      return (_openBlock(), _createBlock(_component_el_table_column, {
                        key: typeIndex,
                        label: '方案' + typeIndex
                      }, {
                        default: _withCtx(({row}) => [
                          _createVNode(_component_el_select, {
                            modelValue: row['type' + typeIndex],
                            "onUpdate:modelValue": ($event: any) => ((row['type' + typeIndex]) = $event),
                            placeholder: "请选择类型"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "节日",
                                value: "Festive"
                              }),
                              _createVNode(_component_el_option, {
                                label: "假日",
                                value: "Holiday"
                              }),
                              _createVNode(_component_el_option, {
                                label: "工作日",
                                value: "WorkDay"
                              })
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
}
}

})